// hooks/useFixCapsLock.ts
import { useEffect } from 'react';

export const useFixCapsLock = () => {
  useEffect(() => {
    const handleKeyDown = (e: Event) => {
      // Проверяем, что это KeyboardEvent
      if (!(e instanceof KeyboardEvent)) return;
      
      // Проверяем, что метод существует
      if (typeof e.getModifierState !== 'function') return;
      
      // Если капслок включен и это буква (латинская или кириллица)
      const isLetter = /^[a-zA-Zа-яА-ЯёЁ]$/.test(e.key);
      if (e.getModifierState('CapsLock') && isLetter) {
        const target = e.target as HTMLElement;
        const isTextInput = 
          target.tagName === 'INPUT' || 
          target.tagName === 'TEXTAREA' ||
          target.isContentEditable;
        
        // Пропускаем не текстовые поля и служебные клавиши
        if (!isTextInput || e.ctrlKey || e.altKey || e.metaKey) return;
        
        e.preventDefault();
        
        // Меняем регистр на противоположный
        const fixedChar = e.key === e.key.toUpperCase() 
          ? e.key.toLowerCase() 
          : e.key.toUpperCase();
        
        // Вставляем текст в зависимости от типа элемента
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          const input = target as HTMLInputElement | HTMLTextAreaElement;
          const start = input.selectionStart || 0;
          const end = input.selectionEnd || 0;
          
          // Вставляем исправленный символ
          input.value = 
            input.value.substring(0, start) + 
            fixedChar + 
            input.value.substring(end);
          
          // Двигаем курсор
          input.setSelectionRange(start + 1, start + 1);
          
          // Триггерим React события
          const inputEvent = new Event('input', { bubbles: true });
          const changeEvent = new Event('change', { bubbles: true });
          input.dispatchEvent(inputEvent);
          input.dispatchEvent(changeEvent);
        } else if (target.isContentEditable) {
          // Для contentEditable элементов
          const selection = window.getSelection();
          if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            const textNode = document.createTextNode(fixedChar);
            range.insertNode(textNode);
            range.setStartAfter(textNode);
            range.setEndAfter(textNode);
            selection.removeAllRanges();
            selection.addRange(range);
            
            // Триггерим события
            const inputEvent = new Event('input', { bubbles: true });
            target.dispatchEvent(inputEvent);
          }
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};